import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';
import { privacyContent as enPrivacy } from '../i18n/privacy/en';
import { privacyContent as zhPrivacy } from '../i18n/privacy/zh';
import { privacyContent as jaPrivacy } from '../i18n/privacy/ja';
import { privacyContent as koPrivacy } from '../i18n/privacy/ko';

export default function PrivacyPolicy() {
  const { t, i18n } = useTranslation();

  const getPrivacyContent = () => {
    switch (i18n.language) {
      case 'zh':
        return zhPrivacy;
      case 'ja':
        return jaPrivacy;
      case 'ko':
        return koPrivacy;
      default:
        return enPrivacy;
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header onSearch={() => {}} />
      
      <div className="flex-1 bg-[#1a1625] pt-16">
        <div className="sticky top-16 bg-[#13111d] border-b border-gray-800 z-40">
          <div className="container mx-auto px-4">
            <div className="flex items-center h-12">
              <Link to="/" className="flex items-center space-x-2 text-white hover:text-purple-400">
                <ArrowLeft className="w-5 h-5" />
                <span>{t('common.privacy_policy')}</span>
              </Link>
            </div>
          </div>
        </div>
        
        <main className="container mx-auto px-4 py-8">
          <div className="bg-[#13111d] rounded-lg p-8 text-white">
            <h1 className="text-3xl font-bold mb-6">{t('privacy.title')}</h1>
            <div 
              dangerouslySetInnerHTML={{ __html: getPrivacyContent() }} 
            />
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
} 